import React from 'react';
import Flexbox from 'flexbox-react';
import FilledButtonWithDropdown from '../buttons-20250224T111359Z-001/buttons/ButtonWithDropdown.jsx';
import ScrollableDropdown from '../shared/ScrollableDropdown.jsx';
import { Divider } from "@blueprintjs/core";
import DepartmentKPITemplates from './DepartmentKPITemplates.jsx';
import { FilledButton } from '../buttons-20250224T111359Z-001/buttons/index.jsx';


const GoalsHeaderButtonsPanel = ({ selectedTimeframe, isManagerFlow, filteredGoalCycles, handleSelectTimeframe, handleSelectDepartmentTemplate, handleAddGoalClick, handleAddCascadingGoalClick, handleSendForApproval, isAccountOwner, userGoalList, isViewingOtherEmployee,isSelectedEmployeeAccountOwner }) => {

    const showPublishBtn = selectedTimeframe.is_editable &&
        userGoalList.some(goal => ['Draft', 'Rejected'].includes(goal.goal_progress_states));
        const toBoolean = value => {if (typeof value === "boolean") return value;return value === "true";};
    
    const showAddGoalBtn = selectedTimeframe.is_editable ;    

    const canCreateCascadingGoal = isManagerFlow
            ? toBoolean(isSelectedEmployeeAccountOwner)
            : toBoolean(isAccountOwner);

        
    return (
        <Flexbox flexDirection="row" gap="10px" justifyContent="flex-end" >
            {selectedTimeframe.is_editable && (
                <div style={{ display: "flex", gap: "10px", marginRight: "10px", alignItems: "center" }}>
                    <DepartmentKPITemplates
                        onSelectDepartment={handleSelectDepartmentTemplate}
                        buttonText="Use Templates"
                    />
                </div>
            )}
            {showAddGoalBtn && (
                canCreateCascadingGoal ? (
                    <FilledButtonWithDropdown
                        text="Add Goal"
                        onClick={handleAddGoalClick}
                       style={{ cursor: "default" }}
                        menuItems={[
                            {
                                text: "Add Goal",
                                icon: "add",
                                onClick: handleAddGoalClick
                            },
                            {
                                text: "Add Cascading Goal",
                                icon: "git-branch",
                                onClick: handleAddCascadingGoalClick
                            }
                        ]}
                    />
                ) : (
                    <FilledButton
                        text={"+ Add Goal"}
                        onClick={() => handleAddGoalClick()}
                    />
                ))}

            <div style={{ position: "relative", width: "250px", marginLeft: "10px" }}>
                <ScrollableDropdown
                    width={250}
                    label={selectedTimeframe.title || "Goal Cycle"}
                    items={filteredGoalCycles}
                    getKey={g => g.id}
                    getLabel={g => g.title}
                    enableSearch={true}
                    onSelect={handleSelectTimeframe}
                />
            </div>
            {showPublishBtn && (
                <>
                    <Divider className="push-10-l push-10-r" vertical="true"></Divider>
                    <FilledButton
                        text={selectedTimeframe.is_goal_approval_required ? "Send for Approval" : "Publish"}
                        onClick={() => handleSendForApproval()}
                        style={{ marginRight: "10px" }}
                    />
                </>
            )}
        </Flexbox>
    );
};

export default GoalsHeaderButtonsPanel;
